import actions from 'redux/actions'
import { getState } from 'redux/core'
import { constants, links, getPrefixedAddressFields, mixpanel } from 'common/helpers'
import {
  setupBegin, setupCommit, callVindicia, syncUserAndSubscription,
  setupBeginPayPal, setupCommitPayPal, callAnalytics,
} from './util'


const begin = (values, endpoint) => {
  // const error = checkRequiredFields(Object.keys(values), [
  //   'code',
  //   'coupon',
  //   'chargeAmount',
  //   'billingFirstName',
  //   'billingLastName',
  //   'billingStreet',
  //   'billingApt',
  //   'billingZipCode',
  //   'billingState',
  //   'billingCity',
  //   'offerType',
  //   'token',
  // ])
  //
  // if (error) {
  //   return Promise.reject(error)
  // }

  const {
    models: {
      me: {
        gender,
        email,
        redeemCoupon: {
          code,
          coupon,
          chargeAmount,
          type: offerType,
        },
      },
    },
  } = getState()

  const { shipping, billing, paymentMethod } = values

  const body = {
    ...getPrefixedAddressFields({ shipping, billing }),
    email,
    gender,
    code,
    coupon,
    offerType,
    chargeAmount,
    paymentType: paymentMethod, // TODO ask backend rename `paymentType` to `paymentMethod`
  }

  const begin = setupBegin({
    endpoint: endpoint || 'rest/coupon/redeem/begin',
    tokenName: constants.requestTokens.redeemCoupon,
  })

  return begin(body)
}

/**
 *
 * @param {number} redeemCouponSession
 */
const commit = setupCommit({
  endpoint: 'rest/coupon/redeem/commit',
  tokenName: constants.requestTokens.redeemCoupon,
})

const handleSuccessRedeem = () => {
  actions.view.paymentPage.setBillingError(false)
  actions.models.me.updateRedeemCoupon({})
  callAnalytics()
  actions.models.router.push(links.thankYou)
}

/**
 *
 * @param {object} values
 * @param {object} values.shipping
 * @param {object} values.billing
 * @param {string} values.paymentType
 * @param {string} values.paymentMethod
 * @returns {*}
 */
const redeemCouponNoCharge = (values) => {
  const { paymentType } = values

  mixpanel.track(constants.analyticsEvents.tech.redeemCouponNoCharge)

  return begin(values, 'rest/coupon/redeem')
    .then(
      (result) => syncUserAndSubscription({ paymentType, ...result }),
      (err) => {
        const { title, message, statusCode, resData: { authCode } } = err

        const isBillingError = authCode === '713'

        actions.view.paymentPage.setBillingError(isBillingError)
        actions.models.modals.open(constants.modals.ServerError, {
          title,
          content: message,
          statusCode,
        })

        return Promise.reject(err)
      }
    )
    .then(handleSuccessRedeem)
}

/**
 *
 * @param {object} values
 * @param {object} values.shipping
 * @param {object} values.billing
 * @param {object} values.creditCard
 * @param {string} values.paymentType
 * @param {string} values.paymentMethod
 * @returns {*}
 */
const redeemCoupon = (values) => {
  const { shipping, billing, creditCard, paymentType } = values

  mixpanel.track(constants.analyticsEvents.tech.redeemCoupon)

  return begin(values)
    .then(
      ({ redeemCouponSession, ...data }) => (
        callVindicia({
          paymentType,
          billing,
          shipping,
          creditCard,
          redeemCouponSession,
          ...data,
        })
          .then(() => commit({ redeemCouponSession }))
      ),
      (err) => Promise.reject(err)
    )
    .then(
      (result) => syncUserAndSubscription({ paymentType, ...result }),
      (err) => {
        const { title, message, statusCode, resData: { isCvvError, authCode } } = err

        const isBillingError = authCode === '713'

        actions.view.paymentPage.setBillingError(isBillingError)

        if (isCvvError) {
          actions.models.modals.open(constants.modals.ErrorCVV, {
            onSubmit: ({ cvv }) => redeemCoupon({ ...values, creditCard: { ...creditCard, cvv } }),
          })
        }
        else {
          actions.models.modals.open(constants.modals.ServerError, {
            title,
            content: message,
            statusCode,
          })
        }

        return Promise.reject(err)
      }
    )
    .then(handleSuccessRedeem)
}

const beginRedeemCouponUsingPayPal = (values) => {
  const beginPayPal = setupBeginPayPal({
    begin,
    sessionName: 'redeemCouponSession',
  })

  return beginPayPal(values)
}

const commitRedeemCouponUsingPayPal = (values) => {
  const commitPayPal = setupCommitPayPal({
    commit,
    sessionName: 'redeemCouponSession',
  })

  return commitPayPal(values)
}


export {
  redeemCoupon,
  redeemCouponNoCharge,
  beginRedeemCouponUsingPayPal,
  commitRedeemCouponUsingPayPal,
}
